import Debug from 'debug';
import { PracticeStateMachineAbstractState, PracticeStateMachineCommonEvents } from './state'
import { PracticeStateMachineData } from '../data'

const debug = Debug('practice-error-state')

interface Events extends PracticeStateMachineCommonEvents {
  onReset: () => void
}

export class PracticeErrorState extends PracticeStateMachineAbstractState<Events> {
  public readonly name = 'error'

  constructor(private state: PracticeStateMachineData,
              private error: unknown) {
    super()
  }

  enter() {
    debug('enter')
    this.state.setCurrentError(this.error)
  }

  exit() {
    debug('exit')
  }

  reset() {
    debug('reset')
    this.triggerEvent(events => events.onReset())
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }
}
